import React from 'react'
import { NavIn2 } from '../components/componentNav/NavIn'
import {ExtendFarplane} from '../components/componentExtens/ExtendFarplane'


export function ForWeb(  ) {
  return (
    <>
      <NavIn2 />
      <ExtendFarplane />
    </>
  )
}